export default __webpack_public_path__ + "static/0258-fb9803f66f4f6f2f918716d5e4096c7c.png";